import React, {useContext, useEffect, useState} from "react";

import {WappContext, withWapp} from "wapplr-react/dist/common/Wapp";
import getUtils from "wapplr-react/dist/common/Wapp/getUtils";

import Menu from "../Menu";
import AppContext from "../App/context";
import {withMaterialStyles} from "../Template/withMaterial";
import Avatar from "../Avatar/me";
import NotFound from "../NotFound";

import getStatus from "../../utils/getStatus";

import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import BackIcon from "@mui/icons-material/ArrowBack";

import clsx from "clsx";

import style from "./style.css";
import materialStyle from "./materialStyle";

import AccountContext from "./context";
import {getPageName} from "./utils";
import getMenu from "./menu";

import Router from "./Router";

import Login from "./Login";
import Signup from "./Signup";
import Settings from "./Settings";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import ChangeData from "./ChangeData";
import ChangeEmail from "./ChangeEmail";
import ChangePassword from "./ChangePassword";
import EmailConfirmation from "./EmailConfirmation";
import DeleteAccount from "./DeleteAccount";
import Logout from "./Logout";

const pages = {
    forgotpassword: ForgotPassword,
    resetpassword: ResetPassword,
    changedata: ChangeData,
    changeemail: ChangeEmail,
    changepassword: ChangePassword,
    emailconfirmation: EmailConfirmation,
    deleteaccount: DeleteAccount,
    settings: Settings,
    signup: Signup,
    login: Login,
    logout: Logout
};

function Account(props) {

    const appContext = useContext(AppContext);
    const context = useContext(WappContext);

    const {
        parentRoute = appContext.routes.accountRoute,
        name = "user"
    } = props;

    const utils = getUtils(context);
    const {subscribe/*, materialStyle*/} = props;

    const {wapp, res} = context;

    wapp.styles.use(style);

    const [user, setUser] = useState(utils.getRequestUser());

    function onUserChange(user){
        setUser((user?._id) ? user : null);
    }

    useEffect(function (){
        const unsub = subscribe.userChange(onUserChange);
        return function useUnsubscribe(){
            unsub();
        }
    }, [subscribe, user]);

    function getTitle() {

        const page = res.wappResponse.route.params.page;
        const pageName = getPageName({user, page});

        if (pageName === "login") {
            return appContext.titles.loginTitle;
        }

        if (pageName === "signup") {
            return appContext.titles.signupTitle;
        }

        if (pageName === "changedata") {
            return appContext.titles.changeDataTitle;
        }

        if (pageName === "changeemail") {
            return appContext.titles.changeEmailTitle;
        }

        if (pageName === "logout") {
            return appContext.titles.logoutTitle;
        }

        if (pageName === "resetpassword") {
            return appContext.titles.resetPasswordTitle;
        }

        if (pageName === "forgotpassword") {
            return appContext.titles.forgotPasswordTitle;
        }

        if (pageName === "changepassword") {
            return appContext.titles.changePasswordTitle;
        }

        if (pageName === "emailconfirmation") {
            return appContext.titles.emailConfirmationTitle;
        }

        if (pageName === "deleteaccount") {
            return appContext.titles.deleteAccountTitle;
        }

        if (pageName === "settings") {
            return appContext.titles.accountTitle;
        }

        return "";
    }

    const page = res.wappResponse.route.params.page;

    const pageName = getPageName({user, page});

    if (!pageName){
        res.wappResponse.status(404)
    }

    const userName = user?.title;

    const avatarClick = () => {
        wapp.client.history.push({pathname: appContext.routes.userRoute + "/" + user._id, search:"", hash:""})
    };

    const backClick = () => {
        wapp.client.history.push({pathname: (pageName === "settings") ? appContext.routes.userRoute + "/" + user._id : appContext.routes.accountRoute, search:"", hash:""})
    };

    const statusManager = wapp.getTargetObject().postTypes.findPostType({name: name}).statusManager;

    return (
        <>
            {(pageName) ?
                <div className={clsx(style.account, {[style[pageName]]: style[pageName]})}>
                    <Container fixed className={style.container} maxWidth={"sm"}>
                        <Paper >
                            {
                                (user?._id) ?
                                    <div className={style.userLayout}>
                                        <div className={style.userBox}>
                                            <div className={style.avatar} onClick={avatarClick}>
                                                <Avatar size={"big"} color={"secondary"}/>
                                            </div>
                                            <div className={style.userNameContainer}>
                                                <div className={style.userName} onClick={avatarClick}>
                                                    <Typography variant="h5" >
                                                        {userName}
                                                    </Typography>
                                                </div>
                                                {(getStatus({user, post:user, appContext, statusManager, name})) ?
                                                    <div className={style.status}>
                                                        <Typography variant={"subtitle1"} color={"textSecondary"} >
                                                            {getStatus({user, post:user, appContext, statusManager, name})}
                                                        </Typography>
                                                    </div>
                                                    :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <AppBar position={"relative"} className={style.appBar} >
                                {(pageName !== "logout") ?
                                    <Toolbar>
                                        {(user?._id) ?
                                            <div>
                                                <IconButton
                                                    color={"inherit"}
                                                    onClick={(pageName !== "settings") ? backClick : avatarClick}
                                                >
                                                    <BackIcon />
                                                </IconButton>
                                            </div>
                                            :
                                            null
                                        }
                                        <div className={style.titleContainer}>
                                            <div className={style.title}>
                                                <Typography variant={"h6"}>
                                                    {getTitle()}
                                                </Typography>
                                            </div>
                                        </div>
                                        {(pageName !== "settings") ?
                                            <Menu
                                                parentRoute={parentRoute}
                                                menu={getMenu({appContext})}
                                                menuProperties={{user, page}}
                                            />
                                            :
                                            null
                                        }
                                    </Toolbar>
                                    :
                                    null
                                }
                            </AppBar>
                            <AccountContext.Provider value={{user, parentRoute, name, page, statusManager}}>
                                <div className={style.content}>
                                    <Router page={page} router={getPageName} pages={pages}/>
                                </div>
                            </AccountContext.Provider>
                        </Paper>
                    </Container>
                </div>
                :
                <NotFound />
            }
        </>
    )
}

const WappComponent = withWapp(Account);

const StyledComponent = withMaterialStyles(materialStyle, WappComponent);

export default StyledComponent;
